export class GeneratedArtifactMeta {
  StudentID: number;
  ArtifactID: string;
  ArtifactType: string;
  DateGenerated: Date;
  CourseCode: string;
  StartedActivityID: string;
  UnitNumber: number;
  ActivityDescription1: string;
  ActivityDescription2: string;
  ActivityImageName: string;
}

export interface SpeechRecPromptMetadata {
  PromptText: string;
  SpeechRecTargets: string; // Format: "target1 | target2 | target3"
  PromptImage: string;
}

export class GeneratedArtifact extends GeneratedArtifactMeta {
  Data: any;
  SpeechRecPromptMetadata?: SpeechRecPromptMetadata;
}
